import * as React from "react";
import { Box, Typography, useTheme, Grid, InputBase } from "@mui/material";
import TableUserList from "../../components/TableUserList";
import { useEffect, useState, useRef } from "react";
import axios from "axios";
import { API_ENDPOINT_URL } from "../../util/api";
import { getLocalItem } from "../../util/helper";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import AddIcon from "@mui/icons-material/Add";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useParams } from "react-router-dom";
import { formatDateYMD_HMS } from "../../util/helper";
import _ from "lodash";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import { useNavigate } from "react-router-dom";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import CheckIcon from "@mui/icons-material/Check";
import CircularProgress from '@mui/material/CircularProgress';

const ResetPassword = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const token = getLocalItem("key");
  const [validate, setValidate] = useState(false);
  const [data, setData] = useState({
    old_pw: "",
    new_pw: "",
    r_new_pw: "",
  });

  const [showAlert, setShowAlert] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("success");
  const [alertMessage, setAlertMessage] = useState("");
  const [showNewPassword, setShowNewPassword] = React.useState(false);
  const [showOldPassword, setShowOldPassword] = React.useState(false);
  const [showRetypeNewPassword, setShowRetypeNewPassword] =
    React.useState(false);

  const handleClickShowNewPassword = () => setShowNewPassword((show) => !show);
  const handleClickShowOldPassword = () => setShowOldPassword((show) => !show);
  const handleClickShowRetypeNewPassword = () =>
    setShowRetypeNewPassword((show) => !show);

  const handleRequest = (url, data) => {
    axios
      .patch(url, data, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        setAlertSeverity("success");
        setAlertMessage(response.data.message);
      })
      .catch((error) => {
        setAlertSeverity("error");
        setAlertMessage(error.response.data.message);
      })
      .finally(() => {
        setShowAlert(true);
        window.scrollTo({ top: 0 });
        setTimeout(() => {
          setShowAlert(false);
        }, 4000); // Hide alert after 4 seconds
      });
  };

  const handleUpdatePassword = () => {
    // Validate username and email
    if (!data.old_pw || !data.new_pw || !data.r_new_pw) {
      setValidate(true);
      return;
    }

    if (data.new_pw != data.r_new_pw) {
      setValidate(true);
      return;
    }

    setLoading(true)
    const url = `${API_ENDPOINT_URL}/update-password/`;
    const data_tmp = {
      old_pw: data.old_pw,
      new_pw: data.new_pw,
      r_new_pw: data.r_new_pw,
    };

    handleRequest(url, data_tmp);
    setLoading(false)
  };

  return (
    <>
      {showAlert && (
        <Stack sx={{ width: "300px", marginLeft: "auto" }} spacing={2}>
          <Alert variant="filled" severity={alertSeverity}>
            {alertMessage}
          </Alert>
        </Stack>
      )}
      <Box
        mt="50px"
        sx={{
          width: "95%",
          textAlign: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            width: "100%",
            textAlign: "center",
          }}
        >
          <Grid container spacing={0}>
            <Grid item lg={6} sm={12} md={6}>
              <Box>
                <Typography
                  variant="h1"
                  fontSize={40}
                  fontWeight="bold"
                  color="#2699fb"
                  textAlign="left"
                >
                  Password Reset
                </Typography>
              </Box>
            </Grid>
          </Grid>

          <Grid container spacing={0} ml="16px" mt={8} item textAlign="left">
            <Grid item xs={4}>
              <Box>
                <Typography variant="h6" fontSize={15} fontWeight="bold">
                  Old Password
                </Typography>
                <InputBase
                  placeholder="Old Password"
                  type={showOldPassword ? "text" : "password"}
                  value={data ? data.old_pw : ""}
                  onChange={(e) => setData({ ...data, old_pw: e.target.value })}
                  sx={{
                    marginTop: "5px",
                    backgroundColor: "#f1f9ff",
                    width: "100%",
                    border: "2px solid #bce0fd",
                    borderRadius: "10px",
                    color: "#2699fb",
                    padding: "8px 15px 8px 15px",
                  }}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowOldPassword}
                        edge="end"
                        sx={{ color: '#2699fb' }}
                      >
                        {showOldPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </Box>
              <Box height="16px" width="100%" alignItems="center" color="red">
                {validate && !data.old_pw ? "Old password required!" : ""}
              </Box>
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid mt={3} item xs={4}>
              <Box>
                <Typography variant="h6" fontSize={15} fontWeight="bold">
                  New Password
                </Typography>
                <InputBase
                  placeholder="New Password"
                  type={showNewPassword ? "text" : "password"}
                  value={data ? data.new_pw : ""}
                  onChange={(e) => setData({ ...data, new_pw: e.target.value })}
                  sx={{
                    marginTop: "5px",
                    backgroundColor: "#f1f9ff",
                    width: "100%",
                    border: "2px solid #bce0fd",
                    borderRadius: "10px",
                    color: "#2699fb",
                    padding: "8px 15px 8px 15px",
                  }}
                  endAdornment={
                    <InputAdornment position="end">
                      {data.new_pw === data.r_new_pw && data.new_pw && (
                        <CheckIcon sx={{ color: '#2699fb' }} />
                      )}
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowNewPassword}
                        edge="end"
                        sx={{ color: '#2699fb' }}
                      >
                        {showNewPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </Box>
              <Box height="16px" width="100%" alignItems="center" color="red">
                {validate && !data.new_pw ? "New password required!" : ""}
              </Box>
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4} mt={3}>
              <Box>
                <Typography variant="h6" fontSize={15} fontWeight="bold">
                  New Password (Re-type)
                </Typography>
                <InputBase
                  placeholder="New Password (Re-type)"
                  type={showRetypeNewPassword ? "text" : "password"}
                  value={data ? data.r_new_pw : ""}
                  onChange={(e) =>
                    setData({ ...data, r_new_pw: e.target.value })
                  }
                  sx={{
                    marginTop: "5px",
                    backgroundColor: "#f1f9ff",
                    width: "100%",
                    border: "2px solid #bce0fd",
                    borderRadius: "10px",
                    color: "#2699fb",
                    padding: "8px 15px 8px 15px",
                  }}
                  endAdornment={
                    <InputAdornment position="end">
                      {data.new_pw === data.r_new_pw && data.r_new_pw && (
                        <CheckIcon sx={{ color: '#2699fb' }} />
                      )}
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowRetypeNewPassword}
                        edge="end"
                        sx={{ color: '#2699fb' }}
                      >
                        {showRetypeNewPassword ? (
                          <VisibilityOff />
                        ) : (
                          <Visibility />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </Box>
              <Box height="16px" width="100%" alignItems="center" color="red">
                {validate && !data.r_new_pw ? "Retype new password required!" : ""}
              </Box>
              <Box height="16px" width="100%" alignItems="center" color="red">
                {validate && data.r_new_pw && (data.new_pw !== data.r_new_pw)? "Password re-type and password does not match!" : ""}
              </Box>
            </Grid>

            <Grid item xs={1} md={1} mt={2}></Grid>

            <Grid item xs={12} md={5} mt={2}>
              <Box>
                {loading ? (
                  <Box padding="11px" mt={4} sx={{ display: 'flex' }}>
                  <CircularProgress />
                </Box>
                ) : (
                  <>
                    <Box
                  mt={5}
                  padding="11px"
                  sx={{
                    backgroundColor: "#2699fb",
                    color: "white",
                    borderRadius: "4px",
                    "&:hover": {
                      cursor: "pointer",
                    },
                    width: 200,
                  }}
                  onClick={handleUpdatePassword}
                >
                  <Typography
                    variant="body1"
                    gutterBottom
                    textAlign="center"
                    m={0}
                    cursor="pointer"
                  >
                    Update Password
                  </Typography>
                </Box>
                  </>
                )}
                
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default ResetPassword;
